import { Chip } from '@mui/material';
import {
  HepsiburadaOrderStatus,
  hepsiburadaOrderStatusNameMap,
} from '../../../interfaces/Hepsiburada/HepsiburadaOrderStatus';

interface HepsiburadaStatusCellProps {
  status: HepsiburadaOrderStatus;
}

export const HepsiburadaStatusCell = (props: HepsiburadaStatusCellProps) => {
  const getColor = () => {
    switch (props.status) {
      case HepsiburadaOrderStatus.OPEN:
        return 'success';
      default:
        return 'error';
    }
  };

  return (
    <Chip
      size='small'
      variant='filled'
      color={getColor()}
      label={hepsiburadaOrderStatusNameMap[props.status]}
    />
  );
};
